module.exports = __webpack_public_path__ + "img/05-door-front.da197905.png";